<template>
  <header
    class="Header flex items-center justify-between bg-primary-500 px-4 text-white md:px-6"
  >
    <nuxt-link
      to="https://www.tichalinka.cz/"
      target="_blank"
    >
      <logo-svg class="w-[100px] lg:w-auto" />
    </nuxt-link>

    <el-button
      link
      class="text-white"
      data-cy="logout"
      @click="useLogout()"
    >
      {{ $t('AppHeader.logout') }}
    </el-button>
  </header>
</template>

<script setup>
import LogoSvg from '~/assets/img/logo.svg';
</script>

<style scoped>
@reference "assets/css/tailwind.css";

.Header {
  width: 100%;
  position: relative;
  z-index: 1210;
  height: var(--header-height-small);

  @media (width >= theme(--breakpoint-md)) {
    height: var(--header-height);
  }
}
</style>
